'use client';

import clsx from 'clsx';
import Link, { LinkProps } from 'next/link';
import { usePathname } from 'next/navigation';
import { AnchorHTMLAttributes, ReactNode } from 'react';

type BasicLinkProps = LinkProps &
    AnchorHTMLAttributes<HTMLAnchorElement> & {
        exact?: boolean;
        children: ReactNode;
        activeClassName?: string;
        className?: string | undefined;
    };

export default function BasicLink({
    href,
    exact,
    children,
    className,
    activeClassName,
    target,
    rel,
    onClick,
}: BasicLinkProps) {
    const pathname = usePathname();
    const isActive = exact ? pathname === href : pathname.startsWith(href);
    const baseUrl = process.env.NEXT_PUBLIC_FRONT_URL || '';
    const currentHref = () => {
        if (href.startsWith('/')) {
            return `${baseUrl}${href}`;
        } else return href;
    };

    return (
        <Link
            href={currentHref()}
            target={target}
            rel={rel}
            className={clsx(className, { [activeClassName as string]: isActive })}
            prefetch={false}
            onClick={onClick}
        >
            {children}
        </Link>
    );
}
